import { Exclude, Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';

export class AddEditAlertParameterDto {
    alertID: number;
    priority = 1;
    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    effectiveDate: Date;
    expireAfterDays: number;
    subject: string;
    text: string;

    @Exclude()
    endDate: Date;
    @Exclude()
    noEndDate: boolean;
    @Exclude()
    createdBy: string;
    @Exclude()
    community: string;
}
